const route = {
    path: '/screens',
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "screens" */ '../../components/views/screens/screens.vue'),
            }
        },
        {
            path: ':id',
            children: [
                {
                    path: '',
                    components: {
                        default:
                            () => import(/* webpackChunkName: "screens" */ '../../components/views/screens/general.vue'),
                        tabBar:
                            () => import(/* webpackChunkName: "screens" */ '../../components/views/screens/tabBar.vue'),
                    }
                },
                {
                    path: 'playlist',
                    components: {
                        default:
                            () => import(/* webpackChunkName: "screens" */ '../../components/views/screens/playlist.vue'),
                        tabBar:
                            () => import(/* webpackChunkName: "screens" */ '../../components/views/screens/tabBar.vue'),
                    }
                },
            ],
        },
    ],
}

module.exports = route;